import { ShowCancelledToggle, type CancelledFilter } from '../../primitives';

/** "My upcoming workshops" on My schedule (phone), with the show-cancelled toggle. */
export function MyUpcomingHeading({ cancelled }: { cancelled: CancelledFilter<unknown> }) {
  return (
    <div className="flex items-center justify-between gap-2" style={{ margin: '0 0 8px' }}>
      <h3 className="nb-h-section" style={{ margin: 0 }}>
        My upcoming workshops
      </h3>
      <ShowCancelledToggle
        showing={cancelled.showCancelled}
        count={cancelled.cancelledCount}
        onToggle={cancelled.toggle}
      />
    </div>
  );
}
